export const config = {
  REACT_APP_BASE_URL: process.env.REACT_APP_BASE_URL,
  REACT_APP_PROFORMA_GENERATOR_MICROSERVICE_BASE_URL: process.env.REACT_APP_PROFORMA_GENERATOR_MICROSERVICE_BASE_URL,
  REACT_APP_TRANCHE_BASE_URL: process.env.REACT_APP_TRANCHE_BASE_URL,
  NODE_ENV: process.env.REACT_APP_NODE_ENV,
  REACT_APP_MIXPANEL_TOKEN: process.env.REACT_APP_MIXPANEL_TOKEN,
  REACT_APP_ENVIRONMENT: process.env.REACT_APP_ENVIRONMENT,
  REACT_APP_GDRIVE_ACCESS_EMAIL: process.env.REACT_APP_GDRIVE_ACCESS_EMAIL
};
